// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","link":"Navigation_link__13qe6","activeLink":"Navigation_activeLink__M+D4I"};